<p-menubar #navbar [model]="items">

</p-menubar>

